var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSidebarArrow = function SvgSidebarArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "sidebar_arrow_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 16 16)",
    fill: "#D9D9D9",
    d: "M16 16h16v16H16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sidebar_arrow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1 8 8.366 5.267a.583.583 0 0 1 0-.85.583.583 0 0 1 .85 0l3.167 3.166c.056.056.097.12.125.192a.621.621 0 0 1 0 .45.543.543 0 0 1-.125.192l-3.167 3.166a.583.583 0 0 1-.85 0 .583.583 0 0 1 0-.85L11.1 8ZM6.35 8 3.616 5.267a.583.583 0 0 1 0-.85.583.583 0 0 1 .85 0l3.167 3.166c.056.056.097.12.125.192a.621.621 0 0 1 0 .45.545.545 0 0 1-.125.192l-3.167 3.166a.583.583 0 0 1-.85 0 .583.583 0 0 1 0-.85L6.35 8Z",
    fill: "#404040"
  }))));
};
export default SvgSidebarArrow;